import { guardString } from "../strings";
import type { NullableFields } from "../types";
import { Constants } from "./constants";
import { getOrderNumberString } from "./get-order-number-string";

export function getSuborderNumberString({
	orderNumber,
	suborderNumber,
}: NullableFields<{
	orderNumber: number;
	suborderNumber: number;
}>) {
	if (!orderNumber || !suborderNumber) return guardString(null);
	const _orderNumber = getOrderNumberString(orderNumber);
	const _suborderNumber = [
		Constants.SUBORDER_NUMBER_PREFIX,
		suborderNumber.toString().padStart(Constants.SUBORDER_NUMBER_PADDING, "0"),
	].join("");

	return [_orderNumber, _suborderNumber].join(Constants.NUMBER_JOINER);
}
